import React from 'react';
import { CircularProgress } from '@mui/material';

import { StyledPageSpinner } from '../constants/styledComponents';

const PageSpinner = ({ color = 'primary' }) => {
  return (
    <StyledPageSpinner>
      <CircularProgress color={color} />
    </StyledPageSpinner>
  );
};

export default PageSpinner;
